import { IStackTokens, Image, Label, Stack } from "@fluentui/react";
import classNames from "classnames";
import React from "react";
import LadySearchingImg from "../images/LadySearching.jpg";
import styles from "../styles/content.module.css";

type Props = {
  title?: string;
  instructions?: string;
};

const GettingStarted = (props: Props) => {
  const stackTokens: IStackTokens = {
    childrenGap: 10,
  };

  return (
    <Stack className={classNames("ms-depth-4", styles.imageContainer)} verticalFill={true} tokens={stackTokens}>
      <Image src={LadySearchingImg} alt=""></Image>
      <h1>
        <Label className={styles.labelContainer}>
          <b>{props.title || "Let's get started! Choose your region and café."}</b>
        </Label>
      </h1>
      <span className={styles.spanContainer}>
        {props.instructions || "Then you can pick the station and add the menu for it."}
      </span>
    </Stack>
  );
};

export default GettingStarted;
